export default __webpack_public_path__ + "static/media/Image14.c8c43b83.png";